import { OPTION_FORMAT, OptionFormatType } from '@/types/enums';
import classNames from 'classnames';
import { ReactNode } from 'react';

interface OptionComponentProps {
    title?: string,
    type: OptionFormatType,
    descriptionClassName?: string,
    contentClassName?: string,
    textDecoration?: string,
    descriptionList?: string[] | ReactNode[],
    descriptionCompList?: ReactNode[],
    otherComponent?: ReactNode,
    specialNote?: string[],
    isPrice?: boolean,
    inputChildren?: ReactNode
}
export default function OptionComponent({ option }: { option: OptionComponentProps }) {
    const { title, textDecoration, descriptionList = [], specialNote = [], descriptionCompList = [],
        otherComponent, descriptionClassName, contentClassName, isPrice = true, type, inputChildren } = option;

    const titleColSelect = (type: OptionFormatType) => {
        switch (type) {
            case OPTION_FORMAT.Option:
                return '個数';
            case OPTION_FORMAT.Insurance:
                return '補償の有無';
            case OPTION_FORMAT.ExtraMileage:
                return '数量';
            case OPTION_FORMAT.DropOff:
                return '追加の有無';
        }
    };

    const titleUnitPrice = (type: OptionFormatType) => {
        switch (type) {
            case OPTION_FORMAT.Option:
            case OPTION_FORMAT.Insurance:
                return '1週間ごとの料金';
            case OPTION_FORMAT.ExtraMileage:
            case OPTION_FORMAT.DropOff:
                return '料金';
        }
    };

    return (
        <div className='leading-[calc(30/14)]'>
            <div className={classNames('mb-5', descriptionClassName)}>
                <div className='flex items-center gap-1'>
                    <div className='size-3 bg-customOrange'></div>
                    <p className='font-semibold'>{textDecoration}</p>
                </div>
                <div>
                    {
                        descriptionList.length > 0 &&
                        descriptionList.map((des, idx) => (
                            <p key={idx}>{des}</p>
                        ))
                    }
                </div>
                <div className={classNames(descriptionCompList.length > 0 && 'mt-2.5')}>
                    {
                        descriptionCompList.length > 0 &&
                        descriptionCompList.map((Comp, idx) => (
                            <div key={idx}>{Comp}</div>
                        ))
                    }
                </div>
            </div>
            {
                otherComponent
            }
            <div className={classNames('mb-5', contentClassName)}>
                {
                    title && (
                        <div className='flex items-center justify-center bg-customOrange min-h-[50px]'>
                            <p className='font-bold text-white'>
                                {title}
                            </p>
                        </div>
                    )
                }

                <div className={classNames('grid items-center bg-[#F8F7F1] border-x border-b border-[#E6E6E6]', type !== OPTION_FORMAT.DropOff ? 'grid-cols-3' : 'grid-cols-2')}>
                    {
                        type !== OPTION_FORMAT.DropOff && <p className='input-common-item h-full flex items-center justify-end  font-medium text-left border-r border-[#E6E6E6]'></p>
                    }
                    <p className='input-common-item h-full flex items-center justify-center text-center font-medium border-r whitespace-nowrap'>
                        {titleUnitPrice(type)}
                    </p>
                    <p className='input-common-item h-full flex items-center justify-center text-center font-medium'>
                        {titleColSelect(type)}
                    </p>

                </div>

                {
                    inputChildren
                }

                <div className='mt-[10px] flex flex-col items-center justify-center text-center text-black-6 text-mid13'>
                    {
                        specialNote?.length > 0 && (
                            specialNote.map((note, idx) => (
                                <p key={idx}>{note}</p>
                            ))
                        )
                    }
                    {
                        isPrice && <p>※価格は全て税込みです</p>
                    }
                </div>
            </div>

        </div>
    );
};
